import { createApi } from '@reduxjs/toolkit/query/react';
import {
  GetScootersLockHistoryParams,
  GetScootersLockHistoryResponse,
  GetScootersLockHistoryResultType,
  ScootersLockHistoryItem,
  GetCoordsHistoriesParams,
  CoordsHistory
} from '../../resources/types/scootersTypes';
import baseQuery from './baseQuery';

export const scootersApi = createApi({
  reducerPath: 'scootersApi',
  baseQuery,
  endpoints: builder => ({
    getScootersLockHistory: builder.query<
      GetScootersLockHistoryResultType,
      GetScootersLockHistoryParams
    >({
      query: params => ({
        params,
        url: 'scooters/lock_history'
      }),
      transformResponse(response: GetScootersLockHistoryResponse) {
        const locked: ScootersLockHistoryItem[] = [];
        const unlocked: ScootersLockHistoryItem[] = [];

        for (const item of response.lockHistory) {
          if (item.lock) {
            locked.push(item);
          } else {
            unlocked.push(item);
          }
        }

        return {
          locked,
          unlocked,
          pages: response.pagination.totalPages
        };
      }
    }),
    getCoordsHistories: builder.query<CoordsHistory[], GetCoordsHistoriesParams>({
      query: (params) => ({
        url: 'scooters/coords_histories',
        params: {
          dateFrom: params.dateFrom,
          dateTo: params.dateTo,
          scooterId: params.scooterId
        }
      }),
      transformResponse(response: any) {
        console.log('=== getCoordsHistories raw response:', JSON.stringify(response).substring(0, 500));
        const data = response?.data || response || [];
        return Array.isArray(data) ? data : [];
      }
    })
  })
});

export const { useGetScootersLockHistoryQuery, useGetCoordsHistoriesQuery } = scootersApi;
